export default "__VITE_ASSET__Bb8$6cX9__"